import React from "react";
import type { User } from "firebase/auth";

type AvatarSize = "sm" | "md" | "lg";

const sizeClass: Record<AvatarSize, string> = {
  sm: "h-6 w-6 text-xs",
  md: "h-9 w-9 text-sm",
  lg: "h-12 w-12 text-lg",
};

export function UserAvatar({ user, size }: { user: User; size: AvatarSize }) {
  const box = sizeClass[size];
  if (user.photoURL) {
    return (
      <img
        src={user.photoURL}
        alt={user.displayName || "User"}
        className={`${box} rounded-full object-cover`}
      />
    );
  }
  return (
    <div
      className={`${box} rounded-full bg-indigo-500 flex items-center justify-center font-semibold shrink-0`}
    >
      {user.email?.[0].toUpperCase()}
    </div>
  );
}
